import React, { Fragment } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { useSelector, useDispatch } from 'react-redux';
import { capitalize } from '@material-ui/core';
import { getPricingAndCoverage, getItemDescription } from 'utils/utils';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import Tooltip from '@material-ui/core/Tooltip';
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: 10,
        textAlign: 'center',
        color: '#ffffff'
    },
    sectionTitle: {
        padding: 10,
        borderRadius: 0,
        textAlign: 'center',
        color: '#ffffff',
        fontWeight: 700,
        letterSpacing: 1,
        fontSize: 14
    },
    rowRoot: {
        '& .MuiTableCell-root': {
            padding: 10
        }
    },
    descriptionUl: {
        margin: 0,
        paddingLeft: 15 
    },
    listStyle: {
        color: '#000000',
        padding: 5
    },
    rightSection: {
        position: 'relative'
    }
}));

const DescToolTip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#ffffff',
        padding: '15px 15px',
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: theme.typography.pxToRem(14),
        border: '1px solid',
        borderColor: '#79abc7',
        boxShadow: 'inset 0px 0px 0px 2px rgb(0, 164, 253)'
    },
}))(Tooltip);

function Coverage(props) {
    const { quoteDataTable, color } = props;
    const classes = useStyles();

    const renderToolTip = (title, quote) => {
        const itemDesc = getItemDescription(title, quote);
        const withToolTips = ['Riot,Strike', 'No_of_Waived_Deductibles', 'Towing', 'Authorized_Repair_Limit', 'Alternative_transport', 'Overnight_Accommodation', 'Removal_crane_services'];
        if( withToolTips.indexOf(title) > -1) {
            if( !_.isEmpty( itemDesc ) ) {
                return(
                    <span  style={{ position: 'absolute', top: 10 }}>
                        <DescToolTip
                            arrow
                            placement="top-start"
                            title={
                            <React.Fragment>
                                <span>
                                    <ul className={ classes.descriptionUl }>
                                    {
                                        itemDesc.map((desc, i) => {
                                            return(
                                                <li key={ `tooltip-desc-item-${ i }` } className={ classes.listStyle }>{ desc }</li>
                                            )
                                        })
                                    }
                                    </ul>
                                </span>
                            </React.Fragment>
                            }
                        >
                            <span style={{ background: '#ffffff' }} className={ classes.colorCode }>
                                <ContactSupportIcon 
                                    fontSize={ `small` } 
                                    style={{ color: '#c5dbe7', cursor: 'pointer' }}
                                />
                            </span>
                        </DescToolTip>
                    </span>
                )
            }
        }
        return null;
    }

    const renderRows = () => {
        const pricingAndCoverage = getPricingAndCoverage(quoteDataTable).coverageData;
        const result = Object.keys(pricingAndCoverage).map(( item, index ) => {
            let title = item;
            
            if(title === 'Riot_Strike') {
                title = title.replace(/_/g, ',');
            }

            const coverage = pricingAndCoverage[item].coverage;
            const currency = isNaN(coverage) ? '' : 'P'
           
            return(
                <TableRow key={ `coverage-row-${ index }`} className={ classes.rowRoot }>
                    <TableCell component="td" scope="row" className={ classes.rightSection }>{ `${ capitalize(title.replace(/_/g, ' ')) }` } { renderToolTip(title, quoteDataTable) }</TableCell>
                    <TableCell component="td" scope="row" align={ 'right' }>{ `${ currency }` }{ coverage.toLocaleString() }</TableCell>
                </TableRow>
            )
        })
        return result;
    }
    return(
        <Fragment>
            <Paper elevation={0} style={{ background: color }} className={ classes.sectionTitle }>Coverage</Paper>
            <TableContainer component={Paper}>
                <Table aria-label="coverage-table">
                    <TableBody>
                        { renderRows() }
                    </TableBody>
                </Table>
            </TableContainer>
        </Fragment>
    )
}

export default Coverage;